import React from 'react';
import { Link } from 'react-router-dom'; // For relative routing
import Footer from './Footer';

const Releases = () => {
  // Sample release data - you would likely fetch this from an API or CMS
  const releases = [
    {
      id: 1,
      title: 'Orpheus Can Speak Any Language',
      date: 'April 9th, 2025',
      description: 'Multilingual Orpheus + Finetuning Guide',
      slug: 'orpheus_can_speak_any_language',
      color: '#FFD6E0' // Pastel pink
    },
    {
      id: 2,
      title: 'Towards Human Sounding TTS',
      date: 'March 19th, 2025',
      description: 'SOTA expressive TTS model.',
      slug: 'towards_human_sounding_tts',
      color: '#C1E1C1' // Pastel green
    },
  ];

  return (
    <div className="flex flex-col min-h-screen font-sans text-gray-900">
      {/* Main Content */}
      <main className="flex-grow px-4 py-8">
        <div className="max-w-6xl mx-auto">
          {/* Releases Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {releases.map((release) => (
              <Link 
                key={release.id} 
                to={`/releases/${release.slug}`} // Relative route
                className="flex flex-col border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300 relative"
              >
                {/* Colored Bar */}
                <div 
                  className="absolute top-0 left-0 bottom-0 w-2" 
                  style={{ backgroundColor: release.color }}
                ></div>
                
                {/* Content with padding to accommodate the bar */}
                <div className="flex-grow p-6 pl-8">
                  <span className="text-sm text-gray-500">{release.date}</span>
                  <h3 className="text-xl font-semibold mt-1 mb-3">{release.title}</h3>
                  <p className="text-gray-700">{release.description}</p>
                </div>
                <div className="p-6 pt-0 pl-8">
                  <span className="text-black font-medium">Read more →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Releases;